import { render } from "./jin-klb.vue?vue&type=template&id=28ae1e25&scoped=true"
import script from "./jin-klb.vue?vue&type=script&lang=js"
export * from "./jin-klb.vue?vue&type=script&lang=js"

import "./jin-klb.vue?vue&type=style&index=0&id=28ae1e25&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ae1e25"]])

export default __exports__